
import Vue from 'vue'
import Skeleton from '@/common/components/Skeleton.vue'

export default Vue.extend({
  components: {
    Skeleton
  },
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    colorPatternOptions: {
      type: Array,
      required: true
    }
  }
})
